<template>
  <div class="container">
    <mt-loadmore 
        :top-method="loadTop" 
        :style="{ height: wrapperHeight + 'px' }"
        ref="loadmore" 
        id="loadmore">
      <div class='top'> 
        <!-- 标题 -->
        <div class='title'>{{hotNews.title}}</div> 
        <div class='info show-flex'>
          <span class='info-abq'>爱比趣</span>
          <span>{{hotNews.inTime}}</span>
        </div>
        <!-- 图片 -->
        <img :src="hotNews.coverUrl | imgUrl" class='top-img'>
        <!-- 内容 -->
        <div class='top-cont' v-html="contentHtml"></div>

        <!-- 图集图片 -->
        <div class='atlas-box'>
          <div class='atl-title show-flex-c'>
            <span class='font-one'>{{picObj.title}}</span>
            <img src='../../static/img/arrow_right_2.png' class='atl-rig-img' />
          </div>
          <div class='atl-img bg-img' :style="{backgroundImage: `url(${picObj.poster})`}">
            <span class='atl-text' data-id='picObj.groupId'>图集</span>
          </div>
        </div>
        
        <!-- 语音块 -->
        <div class="self_voice_wrap sound-box">
          <div v-for="(item,index) in speechList" :key="index">
            <img :src="item.userHeadImg | imgUrl" :data-id="(item.userId)" class="self_head_img" />
            <div class="voice_list_wrap">
              <div class="voice_list"
                :class="[ item.add ? 'scale' : '' ]">
                <img src="../../static/img/icon_triangle.png" class="icon_triangle" />
                <div class="self_voice " :data-index="index" :style="{width : item.width + 'px'}" :data-path="item.src" @click="playMusic(item.src)">
                  <div class="sound"
                    :class="[item.state ? 'playing' : '' ]">
                    <div class="sound1">
                      <div class="sound2 ">
                        <div class="sound3"></div>
                      </div>
                    </div>
                  </div>
                  {{item.duration}}"
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    

      <!--评论-->
      <div class="comment_out">
        <div class="comment_wrap">
          <div v-if="hotCommentList.length">
            <div class="hot_comment_wrap">
              <div class="praise_top comment_top">
                <span class="praise_num">最热评论</span>
              </div>
              <div class="comment_bottom">
                <div class="comment_list" v-for="(item,index) in hotCommentList" :key="index">
                  <img :src="item.userHeadImg | imgUrl" class="praise_img" :data-id="item.userId" @click="goPersonTap"
                  :class="[item.commentAni?'commentScale':'']" />
                  <div class="comment_right">
                    <div class="comment_icon">
                      <div class="comment_like" data-comment="1" :data-idx="index" :data-cid="item.commentId" @click.prevent="praiseComment(1,index,item.commentId,item.praiseState)">
                        <img v-if="!item.praiseState" src="../../static/img/like.png" :data-cid="item.commentId" class="icon_like_c" />
                        <img v-else src="../../static/img/like2.png" :data-cid="item.commentId" class="icon_like_c" />
                        <span>{{item.praiseTotalNum}}</span>
                      </div>
                      <div class="comment_message" :data-cid="item.commentId" :data-name="item.userName" @click="commentTap(item.commentId)">
                        <img src="../../static/img/mes.png" class="icon_message" />
                      </div>
                    </div>
                    <div class="comment_name font-one"
                      :class="[item.userType == 2 ? 'color_name' : '']">
                      {{item.userName}}
                      <img src="../../static/img/vip.gif" class="comment_vip" v-if="item.userType == 2" />
                    </div>
                    <div class="comment_time">{{item.inTime | time}}</div>

                    <div class="comment_cont" v-if="item.replyId==0">{{item.content}}</div>

                    <div v-if="item.replyId>0">
                      <div class="comment_cont">
                        回复
                        <span class="replay_name"
                          :class="[item.replyUserType == 2 ? 'color_name' : '']">@{{item.replyInfo.replyUserName}} </span>
                        <img src="../../static/img/vip.gif" class="comment_vip" v-if="item.replyInfo.isVip" />{{item.content}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="praise_top comment_top" id="comment">
            <span class="praise_num">全部评论</span>
          </div>
          <div v-if="!commentList.length">
            <!-- 评论无内容 -->
            <img src="../../static/img/comment_no.png" class="comment_no_img" @click="commentTap(null)" />
          </div>
          <div class="comment_bottom">
            <div class="comment_list" v-for="(item,index) in commentList" :id='item.bcId' :key="index">
              <img :src="item.userHeadImg | imgUrl" class="praise_img" :data-id="item.userId" @click="goPersonTap"
                :class="[item.commentAni?'commentScale':'']" />
              <div class="comment_right">
                <div class="comment_icon">
                  <div class="comment_like" data-comment="0" :data-idx="index" :data-cid="item.commentId" @click="praiseComment(0,index,item.commentId,item.praiseState)">
                    <img v-if="!item.praiseState" src="../../static/img/like.png" :data-cid="item.commentId" class="icon_like_c" />
                    <img v-else src="../../static/img/like2.png" :data-cid="item.commentId" class="icon_like_c" />
                    <span>{{item.praiseTotalNum}}</span>
                  </div>
                  <div class="comment_message" :data-cid="item.commentId" :data-name="item.userName" @click="commentTap(item.commentId)">
                    <img src="../../static/img/mes.png" class="icon_message" />
                  </div>
                </div>
                <div class="comment_name font-one"
                  :class="[item.userType == 2 ? 'color_name' : '']">
                  {{item.userName}}
                  <img src="../../static/img/vip.gif" class="comment_vip" v-if="item.userType == 2" />
                </div>
                <div class="comment_time">{{item.inTime | time}}</div>

                <div class="comment_cont" v-if="item.replyId==0">{{item.content}}</div>

                <div v-if="item.replyId>0">
                  <div class="comment_cont">
                    回复
                    <span class="replay_name"
                      :class="[item.replyUserType == 2 ? 'color_name' : '']">@{{item.replyInfo.replyUserName}} </span>
                    <img src="../../static/img/vip.gif" class="comment_vip" v-if="item.replyInfo.isVip" />{{item.content}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg_layer bg_layer2" v-if="comFlag" @click="hideComment"></div>
      <div class="textarea_wrap"
        :class="[comFlag ? 'comment_show' : '']">
        <!-- <form report-submit="true" bindsubmit="formSubmit"> -->
          <input :class="comFlag?'':'textarea_none'" autofocus :focus="comFlag" :value="text_value" :placeholder="reply" ref="input" />
          <div class="confirm_btn" @click="commentPost">确定</div>
        <!-- </form> -->
      </div>
      <div class="detail_bottom"
        :class="[comFlag ? 'detail_bottom_hide' : '']">
        <div class="back flex_item" @click="backTap">
          <img src="../../static/img/back.png" />
        </div>
        <div class="message_btn" @click="commentTap(null)">
          来发表下评论吧
        </div>
        <div class="img_out_2 flex_item">
          <button @click="share" class="icon icon_share"></button>
        </div>
      </div>
    </mt-loadmore>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { imgUrl, baseUrl } from '../../static/util/domain';
import { throttle } from '../../static/util/throttle';
import { time } from '../../static/util/time';

let [ offset, offsetState ] =
    [ 0, false ];

export default {
  name: 'HotRemark',
  data () {
    return {
      hId: 1,//热议ID
      jId: '',
      commentId: null,//评论id
      bqCode:'', //比趣code
      
      comFlag: false,   //输入框
      reply: '写评论',//写评论   回复sb
      focus: false,  
      groupId: 0,
      speechList:[],//语音数组
      commentList:[],//评论
      hotCommentList:[],//最热评论
      picObj:{},//图集   图片
      hotNews:{},//热议 内容
      topImg: '',
      contentHtml: '',//热议内容 html
      text_value:'',//输入框内容
      wrapperHeight: 0, //容器高度
    }
  },
  created () {
    offset = 0;
    let { query } = this.$route;

    [ this.hId, this.jId='', this.bqCode='' ] = 
    [ query.hId, query.jId, query.bqCode ];

    this.getDetail();  //热议详情
    this.getRemarkList();//评论
    this.getHotRemark();  //最热评论列表

    document.title='热议';
  },
  mounted(){
    let qu = this.$route.query;
    console.log(qu)
    this.wrapperHeight =
      document.documentElement.clientHeight - $("#loadmore").offset().top;


    try{
      this.bqCode = qu.bqCode || 'AAF5F08393B6C2BE';
    }finally{

    }

    this.scrollPage();//滑动  分页

    this.clearCookie();
  },
  filters:{
    time: time
  },
  methods:{
    //下拉刷新
    loadTop() {
      // this.created();

      offset = 0;
      this.getDetail(true);  //热议详情
      this.getRemarkList(true);//评论
      this.getHotRemark();  //最热评论列表
    },
    //热议详情
    getDetail(refresh = false){
      let { hId, jId } = this;

      this.$http.post(`/heated/detail/${hId};jsessionid=${jId}`)
        .then( res => {
          let d = res.data;
          if(!d.result){
            return;
          }
          if(refresh){
            setTimeout(()=>{
              this.$refs.loadmore.onTopLoaded(); //下拉刷新 重置位置
            },500);
          }
          [ this.hotNews, this.speechList, this.picObj, this.contentHtml ] =
          [ d.heatedNews, d.speechs, d.pictures, d.heatedNews.content ];

          this.picObj.poster = imgUrl(this.picObj.poster);
          this.contentHtml = this.contentHtml.replace(new RegExp("http://localhost:8080/biqu/upload", 'g'), "https://running.osports.cn/biqu_dev/upload");

          this.setSpeecthList();

          
        })
        .catch(err=>{
          console.log(err)
        })
    },
    //评论列表
    getRemarkList(refresh = false){
      let { hId, jId } = this;
      this.$http.post(`/heated/news/comment/list/${hId};jsessionid=${jId}`,this.$qs.stringify({ offset }))
        .then( res => {
          let d = res.data;
          if(!d.list.length){
            return;
          }

          [ offset, offsetState ] = [ d.offset, false ];

          if(!d.result){
            return;
          }

          this.commentList = refresh ? d.list : [...this.commentList, ...d.list];
        })
        .catch( err => {
          console.log(err);
        })

    },
    //最热评论列表
    getHotRemark(){
      let { hId, jId } = this;
      this.$http.post(`/heated/news/hot/comment/${hId};jsessionid=${jId}`)
        .then( res => {
          let d = res.data;
          if(!d.list.length){
            return;
          }
          offset = d.offset;
          if(!d.result){
            return;
          }
          [ this.hotCommentList ] = [ d.list ];
        })
        .catch( err => {
          console.log(err);
        })
    },
    //语音长度设置
    setSpeecthList(){
      let { speechList } = this;
      speechList.map(item => {
        item.width = parseInt(item.duration * 7 + 90);
      })
      
      [ this.speechList ] = [ speechList ];
    },
    //播放音频
    playMusic(src){
      if(src && src.indexOf('http')==-1){
          src = baseUrl + src;
        }
        wx.playVoice({
          filePath: src,
          success: function (res) {
            console.log('success')
          },
          complete: function (res) {
            console.log('play')
            console.log(res)
          }
        })
        setTimeout(()=>{
          wx.downloadVoice({
            url: src,
            success: function (res) {
              var tempFilePath = res.tempFilePath;
              wx.playVoice({
                filePath: tempFilePath,
                success: function (res) {
                  console.log('success')
                },
                complete: function (res) {
                  console.log('complete')
                }
              })
            },
            complete: function (res) {
              console.log(res)
            }
          });
        },1000)


      wx.miniProgram.getEnv(function(res) { 
        console.log(res.miniprogram)
        if(!res.miniProgram){
          return;
        }

        
      })
      
    },
    //星语跳
    goPersonTap(){},
    //评论点赞
    praiseComment(isHot = 0,index,commentId,praiseState = false){
      //已经点过赞 不让再继续点赞
      if(praiseState){
        return;
      }

      let { jId } = this;
      this.$http.post(`/heated/news/comment/praise/${commentId};jsessionid=${jId}`)
        .then( res => {
          let d = res.data;
          if(!d.result){
            return;
          }
          
          for(let item of this.commentList){
            if(commentId == item.commentId){
              [ item.praiseTotalNum, item['praiseState'] ] = [ d.praiseTotalNum, true ];
            }
          }
          for(let item of this.hotCommentList){
            if(commentId == item.commentId){
              [ item.praiseTotalNum, item['praiseState'] ] = [ d.praiseTotalNum, true ];
            }
          }
          

        } )
        .catch( err => {
          console.log(err)
        } )
    },
    //返回
    backTap(){},
    //评论 回复确定
    commentPost(){
      let [ value, commentId, hId, jId, bqCode ] =
          [ this.$refs.input.value, this.commentId, this.hId, this.jId, this.bqCode ];
      console.log(value)
      
      let url = commentId ? 
          `/heated/news/comment/reply/${hId}/${commentId};jsessionid=${jId}` :
          `/heated/news/comment/add/${hId};jsessionid=${jId}` ;
      let data = this.$qs.stringify({ content: value, bqCode });

      this.$http.post( url, data )
        .then( res => {
          let d = res.data;
          if(!d.result){
            if(!d.isLogin){
              // alert(d.message);
              Toast(d.message);
            }
            return;
          }
          //评论  回复 成功
          let { comment } = d;

          this.commentList = [comment, ...this.commentList];

          this.hideComment();

          // setTimeout(()=>{
          //   let scroll_top = $('#comment').offset().top;//评论 位置
          //   $('#loadmore').scrollTop(scroll_top);
          // },300)

        } )
        .catch( err => {
          console.log(err)
        } );
    },
    //添加评论
    addComment(value){
      this.showComment();

    },
    //回复评论
    replyComment(value){

    },
    //显示 输入框  层
    commentTap(commentId){
      [this.commentId, this.comFlag] = [commentId, true];
    },
    // 隐藏 输入框 层
    hideComment(){
      [this.commentId, this.comFlag] = [null, false];
    },
    //分享
    share(){},
    //滑动 分页
    scrollPage() {
      let self = this;
      let initTop = 0;
      $("#loadmore").scroll(
        throttle(() => {
          let i=0;
          console.log(i++)
          let $this = $("#loadmore"),
            scrollTop = $this.scrollTop(); //滚动高度

          //到底加载更多
          let h1 = $this
            .children()
            .height();
          let h2 = $this.height();
          let h3 = h1 - h2 - 200;
          if (scrollTop >= h3) {
            if (scrollTop > initTop + 10) {
              if (offsetState) {
                return;
              }
              offsetState = true;
              self.getRemarkList();
              // alert(contentH - viewH -scrollTop);
            } else {
              //alert("上");
            }
            initTop = scrollTop;
          }

        },100)
      );
    },
    //清除cookie
    clearCookie(){
      // var myDate=new Date();    
      // myDate.setTime(-1000);//设置时间    
      // var data=document.cookie;    
      // var dataArray=data.split("; ");    
      // for(var i=0;i<dataArray.length;i++){    
      //   var varName=dataArray[i].split("=");    
      //   document.cookie=varName[0]+"=''; expires="+myDate.toGMTString();    
      // } 
    },
    
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  font-size: .28rem;
  color: #333;
  text-align: left;
  background: #f7f7f7;
}
#loadmore {
  overflow-y: scroll;
}
.top{
  padding: .266667rem .346667rem;
  background: #fff;
}
.title{
  font-size: .64rem;

}
.info{
  overflow: hidden;
  margin: .333333rem auto .733333rem;
  align-content:center;
  align-items: center;
}
.info span{
  float: left;
  font-size: .32rem;
  color: #808080;
}
.info-abq{
  margin-right: .133333rem;
}

.top-img{
  width: 9.333333rem;
  height: auto;
  margin: 0 auto .4rem;
}
.top-cont{
  font-size: .426667rem;
  line-height: 1.8;
}
.atlas-box{
  box-sizing: border-box;
  width: 9.066667rem;
  border: .013333rem solid #e0e0e0;
  border-radius: .133333rem;
  padding-bottom: .2rem;
  margin-top: .4rem;

}
.atl-title{
  overflow: hidden;
  padding: .346667rem .226667rem;
}
.atl-title span{
  max-width: 7.3rem;
  font-size: .386667rem;
  color: #262626;
  flex: 1;
  -webkit-flex: 1;
  margin-right: .4rem;
}
.atl-rig-img{
  width: .52rem;
  height: .32rem;
  flex: none;
  -webkit-flex: none;
  animation: leftToRight 1s infinite forwards;
  -webkit-animation: leftToRight 1s infinite forwards;
}
.atl-img{
  position: relative;
  width: 8.533333rem;
  height: 4.8rem;
  margin: 0 auto;
}
.atl-text{
  padding: .133333rem .266667rem;
  color: #fff;
  font-size: .32rem;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  right: 0;
  bottom: 0;
  letter-spacing:.08rem;
}
.sound-box{
  padding-top: .4rem;
}
.self_head_img {
  width: 1.066667rem;
  height: 1.066667rem;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}

.voice_list_wrap {
  overflow: hidden;
}

.voice_list {
  float: left;
  margin-left: .36rem;
  overflow: hidden;
  position: relative;
  width: 7.866667rem;
  height: 1.013333rem;
  margin-bottom: .266667rem;
  font-size: .373333rem;
}

.icon_triangle {
  position: absolute;
  left: 0;
  top: .36rem;
  width: .066667rem;
  height: .32rem;
}

.self_voice {
  line-height: 1.013333rem;
  margin-left: .07rem;
  padding: 0 .253333rem;
  background: #23d0a5;
  border-radius: .106667rem;
  text-align: right;
  color: #fff;
  float: left;
  max-width: 7.3rem;
}

@keyframes switch2 {
  0%, 33% {
    opacity: 0;
  }

  34%, 100% {
    opacity: 1;
  }
}

@keyframes switch3 {
  0%, 66% {
    opacity: 0;
  }

  67%, 100% {
    opacity: 1;
  }
}

@-webkit-keyframes switch2 {
  0%, 33% {
    opacity: 0;
  }

  34%, 100% {
    opacity: 1;
  }
}

@-webkit-keyframes switch3 {
  0%, 66% {
    opacity: 0;
  }

  67%, 100% {
    opacity: 1;
  }
}

.sound {
  width: .48rem;
  height: .48rem;
  float: left;
  margin-top: .266667rem;
  margin-right: .173333rem;
}

.sound div {
  width: 100%;
  height: 100%;
  animation: none;
  background-image: url("http://running.osports.cn/biqu/frontWeb/images/sound_3.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.playing .sound1 {
  background-image: url("http://running.osports.cn/biqu/frontWeb/images/sound_1.png");
}

.playing .sound2 {
  background-image: url("http://running.osports.cn/biqu/frontWeb/images/sound_2.png");
  animation: switch2 linear 1s infinite;
}

.playing .sound3 {
  background-image: url("http://running.osports.cn/biqu/frontWeb/images/sound_3.png");
  animation: switch3 linear 1s infinite;
}











.comment_bottom {
  margin-top: .266667rem;
  padding-left: .306667rem;
  overflow: hidden;
}

.replay_name {
  color: #556784;
  display: inline-block;
  margin-right: .133333rem;
  max-width: 4.666667rem;
  vertical-align:bottom;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comment_out {
  overflow: hidden;
  padding-bottom: 1.6rem;
}

.comment_wrap, .hot_comment_wrap {
  background: #fff;
  overflow: hidden;
  margin-top: .266667rem;
}

.praise_top {
  margin-top: .053333rem;
  line-height: 1.093333rem;
  border-left: .133333rem solid #23d0a5;
  padding-left: .186667rem;
  font-size: .426667rem;
  color: #23d0a5;
}

.comment_no_img {
  width: 4.973333rem;
  height: 1.626667rem;
  margin: .933333rem auto 1.6rem;
  display: block;
}

.comment_list {
  overflow: hidden;
  margin-bottom: .64rem;
  color: #959a9e;
}

.praise_img {
  width: 1.04rem;
  height: 1.04rem;
  border-radius: 50%;
  overflow: hidden;
  float: left;
  margin-right: .36rem;
}

.comment_like wx-text {
  float: left;
  font-size: .373333rem;
}

.comment_right {
  overflow: hidden;
  width: 7.946667rem;
  float: left;
  position: relative;
  /* height: 1.04rem; */
}

.comment_icon {
  position: absolute;
  right: 0px;
  height: .453333rem;
  line-height: .453333rem;
  top: -.266667rem;
}

.comment_name {
  font-size: .4rem;
  color: #556784;
  max-width: 4.666667rem !important;
  top: -.026667rem;
}


.comment_name span {
  max-width: 4.133333rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  height: .533333rem;
}

.color_name {
  color: #ff6565;
}

.comment_vip {
  /*float: right;*/
  width: .373333rem;
  height: .373333rem;
  /*margin-left: 10px;*/
  margin-top: .106667rem;
  margin-right: .133333rem;
}

.reply_vip {
  width: .373333rem;
  height: .373333rem;
  margin: .106667rem .133333rem 0;
}

.comment_cont {
  font-size: .4rem;
  float: left;
  margin-top: 1.28rem;
  line-height: .613333rem;
}

.comment_time {
  font-size: .32rem;
  color: #adb3b8;
  top: .586667rem;
}

.comment_name, .comment_time {
  position: absolute;
  left: 0;
  /*width: 100%;*/
}

.comment_icon {
  position: absolute;
  right: 0px;
  height: .453333rem;
  line-height: .453333rem;
  top: -.266667rem;
}

input {
  border: .013333rem solid #c6c7c9;
  border-radius: .053333rem;
  width: 100%;
  max-height: 2.173333rem;
  line-height: .533333rem;
  font-size: .4rem;
  padding: .266667rem;
  background: #fff;
  display: block;
}

.share_out .bg_layer, .bg_layer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index:5;
}

.bg_layer2 {
  top: 0;
}

.share_out .bg_layer {
  height: 7.653333rem;
  bottom: 0;
}

.textarea_none {
  padding: 0;
}

.textarea_wrap {
  background: #f4f5f7;
  overflow: hidden;
  display: none;
  position: fixed;
  left: 0;
  padding: .4rem .333333rem .333333rem;
  top: 0;
  right: 0;
  z-index: 20;
}

.textarea_wrap .confirm_btn {
  float: right;
  margin-top: .213333rem;
  border-radius: .266667rem;
  background: #23d0a5;
  font-size: .4rem;
  width: 1.4rem;
  text-align: center;
  line-height: .7rem;
  color: #fff;
}

.textarea_wrap .cancel_btn {
  margin-right: .266667rem;
}

.comment_show {
  display: block;
}

.detail_bottom_hide {
  display: none !important;
}

.icon_message {
  width: .48rem;
  height: .453333rem;
}

.icon_like {
  width: .693333rem;
  height: .586667rem;
}

.comment_like {
  float: left;
  overflow: hidden;
  max-width: 2.16rem;
  padding: .306667rem;
}

.comment_message {
  float: left;
  width: .986667rem;
  text-align: right;
  padding: .306667rem;
}

.comment_like text {
  float: left;
  font-size: .373333rem;
}

.icon_like_c {
  width: .56rem;
  height: .453333rem;
  /*margin-top: 4px;*/
  float: left;
  margin-right: .16rem;
}

.icon_share {
  width: .56rem;
  height: .666667rem;
  background: url("https://running.osports.cn/biqu/frontWeb/images/share.png") center bottom no-repeat;
  background-size: .56rem .666667rem;
  border-radius: 0;
  box-sizing: content-box;
  padding: 0;
  border: 0;
}

.icon_share::after {
  border: 0;
}

.detail_bottom {
  overflow: hidden;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  border-top: .013333rem solid #cfcfcf;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  height: 1.573333rem;
  z-index:20;
}

.message_btn {
  width: 7.333333rem;
  height: .853333rem;
  border: .013333rem solid #959a9e;
  border-radius: .266667rem;
  line-height: .853333rem;
  font-size: .373333rem;
  text-indent: .373333rem;
  color: #959a9e;
}

.gift_btn img {
  width: .76rem;
  height: .666667rem;
}

.flex_item {
  padding: .333333rem;
  text-align: center;
}

.like_wrap {
  float: left;
  overflow: hidden;
}

.comment_btn {
  float: left;
  width: 4.72rem;
  height: .853333rem;
  line-height: .853333rem;
  font-size: .373333rem;
  color: #959a9e;
  border-radius: .266667rem;
  padding-left: .4rem;
  overflow: hidden;
  border: .013333rem solid #cfcfcf;
}

.back {
  overflow: hidden;
  float: left;
}

.back img {
  width: .586667rem;
  height: .52rem;
}

.arrow_down {
  width: .213333rem;
  height: .12rem;
  margin-left: .213333rem;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
}

.rotate {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}

.like {
  width: .853333rem;
  height: .853333rem;
  flex: none;
  -webkit-flex: none;
}


@keyframes leftToRight {
  0%,100% {
    /* left: 100%; */
    transform: translate(-10px, 0);
    -webkit-transform: translate(-10px, 0);
  }
  50%{
    transform: translate(10px, 0);
    -webkit-transform: translate(10px, 0);
  }
}

@-webkit-keyframes leftToRight {
  0%,100% {
    /* left: 100%; */
    transform: translate(-10px, 0);
    -webkit-transform: translate(-10px, 0);
  }
  50%{
    transform: translate(10px, 0);
    -webkit-transform: translate(10px, 0);
  }
}


/*图集*/
.atlas-wrap{
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 20px;
  z-index: 10;
}
.altas-con{
  background: rgba(0, 0, 0, 0.6);
  font-size: 24px;
  width: 100px;
  height: 40px;
  color: #fff;
  border-radius: 10px;
}
.altas-img{
  width: 24px;
  height: 24px;
  margin-right:6px;
}

</style>



// WEBPACK FOOTER //
// src/pages/HotRemark.vue